<template lang="html">
  <div class="container" id="text-page">
    <h1 class="mb-3 page-title txt-black">Privacy Policy</h1>

    <p>
      <strong>Effective Date:</strong> February 17th 2025.
    </p>

    <br />
    <p>
      Eslowindows ("Company," "we," "our," or "us") respects your privacy and is committed to protecting it through this Privacy Policy.
    </p>

    <br />
    <h6>1. Information We Collect</h6>
    <p>
      We collect the following types of information:
    </p>
    <ul>
      <li>
        <strong>Personal Information:</strong> Name, email address, phone number, and any other details you provide when contacting us.
      </li>
      <li>
        <strong>Usage Data:</strong> Information about how you use our website, such as IP address, browser type, and browsing behavior.
      </li>
      <li>
        <strong>Cookies and Tracking Technologies:</strong> We use cookies to enhance user experience and analyze website performance.
      </li>
    </ul>

    <br />
    <h6>2. How We Use Your Information</h6>
    <p>
      We use the collected information to:
    </p>
    <ul>
      <li>Provide, operate, and improve our website and services.</li>
      <li>Respond to your inquiries and provide customer support.</li>
      <li>Monitor website performance and improve user experience.</li>
      <li>Comply with legal obligations.</li>
    </ul>

    <br />
    <h6>3. Sharing of Information</h6>
    <p>
      We do not sell, trade, or rent your personal information. However, we may share it with:
    </p>
    <ul>
      <li>
        <strong>Service Providers:</strong> Third-party partners who assist in website maintenance and analytics.
      </li>
      <li>
        <strong>Legal Authorities:</strong> If required by law, we may disclose information to comply with legal obligations.
      </li>
    </ul>

    <br />
    <h6>4. Data Security</h6>
    <p>
      We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, or disclosure.
    </p>

    <br />
    <h6>5. Your Rights</h6>
    <p>
      Depending on your location, you may have rights regarding your personal information, including:
    </p>
    <ul>
      <li>
        The right to access, correct, or delete your personal data.
      </li>
      <li>
        The right to opt out of marketing communications.
      </li>
    </ul>
    <p>
      To exercise these rights, contact us at info@eslowindows.com.
    </p>

    <br />
    <h6>6. Third-Party Links</h6>
    <p>
      Our website may contain links to external websites. We are not responsible for their privacy practices and encourage you to review their policies.
    </p>

    <br />
    <h6>7. Changes to This Policy</h6>
    <p>
      We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
    </p>

    <br />
    <h6>8. Contact Us</h6>
    <p>
      If you have any questions about this Privacy Policy, please contact us at:
    </p>

    <br />
    <p>
      <strong>Eslowindows</strong><br />
      1250 East 6600 South, Murray, UT 84121<br />
      Email: info@eslowindows.com
    </p>

  </div>
</template>

<script>
export default {
}
</script>
